<template>
  <div :class="[$style.status_screen, $style[status]]">
    <h1>{{ $t(passed ? 'status.pass' : 'status.fail') }}</h1>
  </div>
</template>

<script type="text/babel">
import axios from 'axios';
import passport from '../helpers/passport';

const jsPDF = require('jspdf/dist/jspdf.node.min');

export default {
  name: 'Status',
  data() {
    return {
      status: null,
      passed: null,
    };
  },
  created() {
    this.passed = this.$route.params.passed;
    this.status = (this.passed) ? 'success' : 'error';
  },
  mounted() {
    if (this.passed) {
      const doc = passport(jsPDF, {
        ...this.$store.getters.getVisitor,
        size: [84, 54],
      });

      const formData = new FormData();
      formData.append('file', doc.output('blob'));

      axios.post('http://localhost:3000/print-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    setTimeout(() => {
      if (!this.passed) {
        this.$router.push({
          name: 'clues',
          params: {
            reload: false,
          },
        });
      } else {
        this.$router.push('/');
      }
    }, 10000);
  },
};
</script>

<style module lang="scss">
  .status_screen {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    h1 {
      font-size: 5em;
    }
  }
  .error {
    background: #F44336;
  }
  .success {
    background: #8BC34A;
  }
</style>
